import { api } from "./api";

export const login = (params) => {
  return api.post("/manufacturer/auth/login", JSON.stringify(params));
};

export const logoutApi = (params) => {
  return api.delete("/manufacturer/auth/logout");
};

export const portalLoginApi = (params) => {
  return api.post("/manufacturer/auth/portal-login", JSON.stringify(params));
};

export const createNewPasswordApi = (params) => {
  return api.post(`manufacturer/auth/create-new-password`, JSON.stringify(params))
}

export const forgotPasswordApi = (params) => {
  return api.post(`/manufacturer/auth/forgot-password`, JSON.stringify(params))
}

export const resetPasswordApi = (params) => {
  return api.post(`/manufacturer/auth/reset-password`, JSON.stringify(params))
}